import { Box } from '@factorialco/deprecated-design-system'

import Filter from 'modules/core/components/Filter'
import i18n from 'modules/core/lib/i18n'

import { MapItem } from 'modules/attendance/components/ClockIn/Shifts/HourlyShifts/HourlyTable/DayRow/ShiftPanelTableBody/ShiftRow/ShiftLocationMap/types'

interface Props {
  mapItems: MapItem[]
  onChange: (visibleMarkerIds: number[]) => void
}

export const MapSelector = ({ mapItems, onChange }: Props) => {
  const options = mapItems.map((item) => {
    return {
      label: item.label,
      value: item.id,
    }
  })
  const commonProps = {
    defaultOpen: false,
    hideSearch: true,
  }
  return (
    <Box paddingBottom={'s24'}>
      <Filter.MultipleChoice
        options={options || []}
        value={mapItems.filter((item) => item.selected === true).map((item) => item.id)}
        label={i18n.t('clock_in.map.filter_title')}
        onValueChange={(visibleMarkerIds) => {
          onChange(visibleMarkerIds || [])
        }}
        {...commonProps}
      />
    </Box>
  )
}
